module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/30@3x.png?1.0.39";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-paytable/30@3x.png
// module id = 766
// module chunks = 0